// extracted by mini-css-extract-plugin
export default {"deviceSelector":"styles_deviceSelector__hJi6A","deviceValue":"styles_deviceValue__Bownd","deviceOptions":"styles_deviceOptions__E7j5g"};